<div *ngIf="isLoading$ | async" class="loading-overlay">
    <div class="spinner"></div>
</div>